import { css } from 'emotion';

import { breakpoints, icons } from '../styles';

export const overlayTitle = css`
  margin: 20px 10px 10px 10px;
`;

export const optionsContainerScroll = (hasSearchBox: boolean) => {
  const topOptionMargin = 20;
  const optionHeight = 20;
  const bottomOptionMargin = 20;
  const optionContainerHeight =
    topOptionMargin + optionHeight + bottomOptionMargin;

  const searchBoxTopMargin = 10;
  const searchBoxHeight = 40;
  const searchBoxContainerHeight = hasSearchBox
    ? searchBoxTopMargin + searchBoxHeight
    : 0;

  return css`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    min-height: ${`${optionContainerHeight + searchBoxContainerHeight}px`};
    width: 100%;
  `;
};

export const optionsContainer = css`
  display: flex;
  flex-wrap: wrap;
  padding: 8px 0px 0px 12px;
  width: 100%;
`;

export const clearFilterButton = css`
  && {
    height: 20px;
    max-width: 90px;
    margin: 20px;
    justify-content: flex-start;
  }
`;

export const filterActions = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px;
`;

export const icon = css`
  height: ${icons.size.small};
  margin-right: 10px;

  & > svg {
    font-size: ${icons.size.small};
  }
`;

export const paperCustomStyle = {
  root: {
    display: 'flex',
  },
};

export const overlay = css`
  display: flex;
  flex-direction: column;
  min-width: 275px;
  box-sizing: border-box;

  @media screen and (max-width: ${breakpoints.tablet}) {
    width: 275px;
  }
`;

export const cancelButton = css`
  && {
    margin-right: 40px;
    margin-left: auto;
  }
`;

export const checkbox = css`
  > :not(:last-child) {
    margin-bottom: 20px;
  }
`;

export const chip = css`
  > div {
    margin-bottom: 10px;

    &:not(:last-child) {
      margin-right: 20px;
    }
  }
`;

export const searchBox = css`
  margin: 10px 10px 0;
`;

export const noOptionsPlaceholder = css`
  margin: 20px;
  display: flex;
  align-items: center;
`;

export const scrollBar = css`
  scrollbar-gutter: stable;
  &::-webkit-scrollbar {
    width: 6px;
    background: #f3f1f1;
    border-radius: 50px;
  }
  &::-webkit-scrollbar-thumb {
    border: 2px solid #5d7186;
    border-radius: 6px;
    height: 20px;
    background-color: #5d7186;
    background-clip: content-box;
  }
`;
